import React, { useEffect, useRef, useState } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { GraduationCap, Award } from 'lucide-react';

const Education = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section
      id="education"
      ref={sectionRef}
      className="section-padding py-20 px-6"
    >
      <div className="max-w-6xl mx-auto">
        <div
          className={`transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="section-title text-4xl md:text-5xl font-bold text-white mb-4">
            <span className="text-cyan-400 font-mono text-lg">04.</span> Education & Certifications
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-cyan-400 to-blue-500 mb-12"></div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* Education */}
            <Card className="glass-card bg-white/5 backdrop-blur-lg border border-white/10 rounded-2xl overflow-hidden hover:border-cyan-400/30 transition-all duration-300 hover:shadow-lg hover:shadow-cyan-400/10">
              <CardContent className="p-8">
                <div className="flex items-start gap-4">
                  <div className="p-4 bg-cyan-500/10 rounded-lg border border-cyan-400/20">
                    <GraduationCap className="w-8 h-8 text-cyan-400" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-white mb-2">
                      Computer Engineering
                    </h3>
                    <p className="text-cyan-400 font-semibold text-lg mb-2">
                      Hacettepe University
                    </p>
                    <p className="text-gray-400">Ankara, Türkiye</p>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Certification */}
            <Card className="glass-card bg-white/5 backdrop-blur-lg border border-white/10 rounded-2xl overflow-hidden hover:border-cyan-400/30 transition-all duration-300 hover:shadow-lg hover:shadow-cyan-400/10">
              <CardContent className="p-8">
                <div className="flex items-start gap-4">
                  <div className="p-4 bg-cyan-500/10 rounded-lg border border-cyan-400/20">
                    <Award className="w-8 h-8 text-cyan-400" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-white mb-2">
                      Registered Scrum Master
                    </h3>
                    <p className="text-cyan-400 font-semibold text-lg mb-2">
                      Scrum Inc.™
                    </p>
                    <p className="text-gray-400">Certified Scrum Professional</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Languages */}
          <Card className="glass-card bg-white/5 backdrop-blur-lg border border-white/10 rounded-2xl overflow-hidden hover:border-cyan-400/30 transition-all duration-300 mt-6">
            <CardContent className="p-8">
              <h3 className="text-2xl font-bold text-white mb-6">Languages</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div>
                  <p className="text-cyan-400 font-semibold text-lg mb-1">
                    Turkish
                  </p>
                  <p className="text-gray-400">Native</p>
                </div>
                <div>
                  <p className="text-cyan-400 font-semibold text-lg mb-1">
                    English
                  </p>
                  <p className="text-gray-400">iTEP 4.7</p>
                </div>
                <div>
                  <p className="text-cyan-400 font-semibold text-lg mb-1">
                    French
                  </p>
                  <p className="text-gray-400">A2</p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Education;